import React from 'react';
import './FeedSide.css';
import SidebarRow from './SidebarRow.js';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import PeopleIcon from '@material-ui/icons/People';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import LocalMallIcon from '@material-ui/icons/LocalMall';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import MovieIcon from '@material-ui/icons/Movie';
import {Link} from "react-router-dom";

function FeedSide({username, profilePic, userId, menuOpen, menuopen}) {
    return (
        <div className={`feedside ${menuOpen && "feedside__show"}`}>
            <div className="top__sidebar">
                <Link to={`/account/${userId}`} >
                    <SidebarRow src={profilePic? profilePic:"true"} title={username}
                    click={menuopen} />
                </Link>
            </div>
            <SidebarRow Icon = {PeopleIcon} title='Friend Lists' className="friend"/>
            <Link to="/">
                <SidebarRow Icon = {GroupWorkIcon} title = 'Post Collection you can view' className="messenger" />
            </Link>
            <Link to={`/story/${userId}`}>
                <SidebarRow Icon = {MenuBookIcon} title = "Blog Story" className="story" />
            </Link>
            <Link to={`/photo/${userId}`}>
                <SidebarRow Icon = {PhotoLibraryIcon} title = 'Photo Library' className="photo" />
            </Link>
            <Link to={`/video/${userId}`}>
                <SidebarRow Icon = {VideoLibraryIcon} title = "Video Library" className="video" />
            </Link>
            <Link to={`/movie/${userId}`}>
                <SidebarRow Icon = {MovieIcon} title = "Movie Library" className="movie" />
            </Link>
            <Link to={`/shop/${userId}`}>
                <SidebarRow Icon = {LocalMallIcon} title = "Shops" className="shop" />
            </Link>
            <SidebarRow Icon = {QueryBuilderIcon} title = "Saved Items" className="save" />
            <p className="footer__text feed__footer"> Privacy . Terms . Memory Site &copy; {new Date().getFullYear()} : Coded by YMH</p>
        </div>
    )
}

export default FeedSide
